import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  commonLocation: {},
};

export const commonLocationSlice = createSlice({
  name: "commonLocation",
  initialState,
  reducers: {
    setCommonLocation: (state, action) => {
      state.commonLocation = action.payload.commonLocation;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCommonLocation } = commonLocationSlice.actions;
export const getCommonLocation = (state) => {
  return state.commonLocation.commonLocation;
};

export default commonLocationSlice.reducer;
